import React from "react"
import 'normalize.css'
import Banner from '../components/banner/Banner' 
import TeacherComponent from '../components/teachers/Teachers.component'
import EdoSolutions from '../components/eduSolutions/EduSolutions'
import Achivements from '../components/achivements/Achivements' 
import Blog from '../components/blogs/Blog'
import Footer from '../components/footer/Footer'
import Indicator from '../components/indicator/Indicator'
import Courses from '../components/coursesHom/Courses'
import Navbar from '../components/Head/Navbar'



const IndexPage = () => (
  <div>
    <Navbar />
    <Banner />
    <Indicator />
    <EdoSolutions />
    <Achivements />
    <Courses />
    <TeacherComponent />
    <Blog /> 
     <Footer />

    
  </div>
)

export default IndexPage
